export function LoadingComponent() {
  return (
    <div className="d-flex flex-column align-items-center loading">
      <div
        aria-hidden="true"
        className="spinner-border text-primary"
        role="status"
        style={{ width: '3rem', height: '3rem' }}
      />
      <p>Loading...</p>
    </div>
  );
}
